export interface Loan {
    amount: number;
    term: number;
    name: string;
    paymentBands?: PaymentBand[];
    mortgageAmount?: number;
}

export interface PaymentBand {
    minAmount: number;
    maxAmount: number;
    apr: number;
    minTerm: number;
    maxTerm: number;
    fixedFee?: number;
}

export interface LoanOption {
    name: string;
    icon?: string;
    paymentBands?: PaymentBand[];
    defaultTerm?: number;
    defaultMortgageAmount?: number;
    tsandcs?: string;
    loanType?: string;
    berRatingBands?: BerRatingBand[];
    minAmount?: number;
    maxAmount?: number;
    maxAmountOptions?: {
        includingGrants?: boolean;
        includingDiscounts?: boolean;
    };
}

export interface BerRatingBand {
    berRating: string,
    apr: number;
}

export enum LoanType {
    Loan = "Loan",
    Mortgage = "Mortgage",
}

export interface MortgageOption {
    yearsRemaining: number;
    outstandingAmount: number;
}